// extracted by mini-css-extract-plugin
module.exports = {"bodyAlert":"AlertDelArticle_bodyAlert__3suzm","btnCancel":"AlertDelArticle_btnCancel__2gSgS"};